function setOverlayPointerEvents(enabled) {
  const overlays = document.querySelectorAll('.map-overlay');
  for (const overlay of overlays) {
    overlay.style.pointerEvents = enabled ? 'auto' : 'none';
  }
}

export function disableOverlayPointerEvents() {
  setOverlayPointerEvents(false);
}

export function enableOverlayPointerEvents() {
  setOverlayPointerEvents(true);
}
